import React from 'react';

// @atlaskit
import Button from '@atlaskit/button';

import { Messages } from '../../../components';

class DevMessages extends React.Component {
  constructor(props) {
    super(props);
    this.onFlagToggle = this.onFlagToggle.bind(this);
    this.onInlineMessageToggle = this.onInlineMessageToggle.bind(this);
    this.onModalToggle = this.onModalToggle.bind(this);
    this.onSectionMessageToggle = this.onSectionMessageToggle.bind(this);

    this.state = {
      modal: false,
      sectionMessage: true,
      inlineMessage: true,
      flag: true,
    };

    this.items = [
      {
        appearance: 'error',
        description: 'Dolor sint tempor veniam deserunt info.',
        title: 'Error Title',
      },
      {
        appearance: 'info',
        description: 'Dolor sint tempor veniam deserunt info.',
        title: 'Info Title',
        width: 'medium',
      },
      {
        appearance: 'success',
        description: 'Dolor sint tempor veniam deserunt success.',
        title: 'Success Title',
      },
      {
        appearance: 'warning',
        description: 'Dolor sint tempor veniam deserunt warning.',
        title: 'Warning Title',
      },
      {
        description: 'Multiple actions',
        actions: [{
          appearance: 'primary',
          text: 'Primary action',
          onClick: () => window.console.log('Primary action clicked!'),
        }, {
          text: 'Secondary action',
          onClick: () => window.console.log('Secondary action clicked!'),
        }],
      },
    ];

    this.modal = [
      this.items[0],
      this.items[1],
      this.items[3],
      this.items[4],
    ];
  }

  onModalToggle() {
    this.setState({ modal: !this.state.modal });
  }

  onSectionMessageToggle() {
    this.setState({ sectionMessage: !this.state.sectionMessage });
  }

  onInlineMessageToggle() {
    this.setState({ inlineMessage: !this.state.inlineMessage });
  }

  onFlagToggle() {
    this.setState({ flag: !this.state.flag });
  }

  render() {
    return (
      <div>
        <p>
          The common component used for multiple alert messages used on the application.
          You can use many components, such as Modal, SectionMessage.
        </p>

        <h3>Modal</h3>
        {this.state.modal ? (
          <p>
            <Messages
              component="Modal"
              items={this.modal}
              onClose={this.onModalToggle}
            />
            All alerts enabled
          </p>
        ) : <p>You haven&#39;t opened any yet</p>}
        <p>
          <Button onClick={this.onModalToggle}>
            {this.state.modal ? 'Close all' : 'Open all'}
          </Button>
        </p>

        <h3>Section Message</h3>
        {this.state.sectionMessage ? (
          <Messages
            items={this.items}
            onClose={this.onSectionMessageToggle}
          />
        ) : <p>You haven&#39;t opened any yet</p>}
        <p>
          <Button onClick={this.onSectionMessageToggle}>
            {this.state.sectionMessage ? 'Close all' : 'Open all'}
          </Button>
        </p>

        <h3>Inline Message</h3>
        {this.state.inlineMessage ? (
          <Messages
            component="InlineMessage"
            items={this.items}
            onClose={this.onInlineMessageToggle}
          />
        ) : <p>You haven&#39;t opened any yet</p>}
        <p>
          <Button onClick={this.onInlineMessageToggle}>
            {this.state.inlineMessage ? 'Close all' : 'Open all'}
          </Button>
        </p>

        <h3>Flag</h3>
        {this.state.flag ? (
          <Messages
            component="Flag"
            items={this.items}
            onClose={this.onFlagToggle}
          />
        ) : <p>You haven&#39;t opened any yet</p>}
        <p>
          <Button onClick={this.onFlagToggle}>
            {this.state.flag ? 'Close all' : 'Open all'}
          </Button>
        </p>
      </div>
    );
  }
}

export default DevMessages;
